import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import ParameterCard from '../ParameterCard'
import PropTypes from 'prop-types'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'
import { IconButton, Tooltip, Typography } from '@mui/material'
import ArrowOutwardOutlinedIcon from '@mui/icons-material/ArrowOutwardOutlined'
import { SeeCmsCategIconTooltip, SeeCmsIconTooltip, SeeOtherIconTooltip } from '../SeeIconTooltip'
import cmsTitleHelp from 'assets/pictures/observatory/cmsTitreHelp.webp'
import cmsHomeHelp from 'assets/pictures/observatory/cmsAccueilHelp.webp'
import cmsInfosHelp from 'assets/pictures/observatory/cmsInfosHelp.webp'
import cmsPartnersHelp from 'assets/pictures/observatory/cmsPartenairesHelp.webp'
import categorieCmsCGUHelp from 'assets/pictures/observatory/categorieCmsCGUHelp.webp'
import idRecaptchaContactHelp from 'assets/pictures/observatory/idRecaptchaContactHelp.webp'
import contactPageLinkHelp from 'assets/pictures/observatory/contactPageLinkHelp.webp'
import { shallowEqual, useSelector } from 'react-redux'
import { omit } from 'lodash'

const LoginPageParameters = ({
    isGlobal = false,
    defaultProps = {},
}) => {
    const {
        cmsCategories,
    } = useSelector(store => ({
        cmsCategories: store.EventsReducer.cmsCategories,
    }), shallowEqual)

    const formattedCategories = useMemo(() => cmsCategories.map(cc => omit(cc, 'icon')), [cmsCategories])

    return (
        <ParameterCard title={i18n.loginPage} isGlobal={isGlobal}>
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='cmsTitre'
                title={i18n.articleLogoTitleCms}
                helpImage={cmsTitleHelp}
                iconTooltip={<SeeCmsIconTooltip />}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='cmsAccueil'
                title={i18n.articleObservatoryPanelCms}
                helpImage={cmsHomeHelp}
                iconTooltip={<SeeCmsIconTooltip />}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='cmsInformations'
                title={i18n.articleInformationPanelCms}
                helpImage={cmsInfosHelp}
                iconTooltip={<SeeCmsIconTooltip />}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='categorieCmsPartenaires'
                title={i18n.articleCategoryPartnersLogos}
                helpImage={cmsPartnersHelp}
                iconTooltip={<SeeCmsCategIconTooltip />}
                options={formattedCategories}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='categorieCmsCGU'
                title={i18n.articleCategoryCGU}
                helpImage={categorieCmsCGUHelp}
                options={formattedCategories}
                description={
                    <Typography variant='italicSubtitle'>
                        {i18n.articleCategoryCGUDescription}
                        <Tooltip title={i18n.seeDefaultCGU} placement='right'>
                            <IconButton onClick={() => window.open('https://aquasys.fr/conditions-generales-dutilisation/', '_blank').focus()}>
                                <ArrowOutwardOutlinedIcon sx={{ fontSize: '1rem' }} />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                }
                iconTooltip={<SeeCmsCategIconTooltip />}
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter='idRecaptchaContact'
                title={i18n.recaptchaId}
                helpImage={idRecaptchaContactHelp}
                placeholder='6Lew_'
                iconTooltip={
                    <SeeOtherIconTooltip
                        title={i18n.seeRecaptcha}
                        link='https://console.cloud.google.com/security/recaptcha?authuser=2&hl=fr&project=qaptys-notifications&pli=1'
                    />
                }
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter='contactPageLink'
                title={i18n.linkToAnotherContactPage}
                helpImage={contactPageLinkHelp}
                placeholder='https://example.fr/contact/'
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter='pageAfterLogin'
                title={i18n.homePage}
                placeholder='/home'
            />
        </ParameterCard>
    )
}

LoginPageParameters.propTypes = {
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default LoginPageParameters
